import { combineReducers } from 'redux';
import show from './show';
import update from './update';

export default combineReducers({show, update});
